export default {
  paged: {
    select:
      'id,isActive,created,entityDisplayName,shortenedUrlCode,entityId,redirectUrl,allowedDomains',
    searchSelect: ['entityDisplayName', 'shortenedUrlCode', 'entityId', 'redirectUrl'],
    orderBy: 'created desc',
  },
};
